/**
 * AppShell — wraps every in-app route with the Abyss sidebar layout.
 *
 * The ActivityTimeline strip and RewindProvider were removed in the
 * monitor-only conversion (their data sources — decision log + outlet
 * event log — no longer exist).
 */
import { type ReactNode } from 'react';

import { AccessKeyGate } from './AccessKeyGate';
import { CausticOverlay } from './CausticOverlay';
import { KeyboardCheatSheet } from './KeyboardCheatSheet';
import { MobileNav } from './MobileNav';
import { PiConnectionBanner } from './PiConnectionBanner';
import { Sidebar } from './Sidebar';

export function AppShell({ children }: { children: ReactNode }) {
  return (
    <>
      <div className="flex min-h-screen w-full">
        {/* Caustic light shimmer — fixed behind all content, pointer-events-none */}
        <CausticOverlay />
        <Sidebar />
        <MobileNav />
        {/*
          pt-12 clears the fixed mobile top bar; collapses to 0 at ≥768px
          where the desktop sidebar owns the chrome.
        */}
        <div className="flex-1 min-w-0 flex flex-col pt-12 md:pt-0">
          <PiConnectionBanner />
          <main className="flex-1">{children}</main>
        </div>
      </div>

      {/* Passcode prompt — appears when the Pi answers 401 */}
      <AccessKeyGate />

      {/* Global keyboard cheat-sheet — ? to open, Esc to close */}
      <KeyboardCheatSheet />
    </>
  );
}
